export const LEFT_GAP = 'previous_ellipsis';
export const RIGHT_GAP = 'next_ellipsis';
export const DEFAULT_PAGINATION_WINDOW = 2;

export type PageNumber = number | typeof LEFT_GAP | typeof RIGHT_GAP;

export function range(from: number, to: number): number[] {
  const array: number[] = [];

  for (let i = from; i <= to; i += 1) {
    array.push(i);
  }

  return array;
}

export function getMiddleRange(currentPage: number, paginationWindow: number, totalPages: number): number[] {
  let windowFrom = currentPage - paginationWindow;
  let windowTo = currentPage + paginationWindow;

  if (windowTo > totalPages) {
    windowFrom -= windowTo - totalPages;
    windowTo = totalPages;
  }

  if (windowFrom < 1) {
    windowTo += 1 - windowFrom;
  }

  return range(
    Math.max(1, windowFrom + 1),
    Math.min(windowTo, totalPages),
  );
}

export function getLeftRange(paginationWindow: number, middleRange: number[]): PageNumber[] {
  if (middleRange.length === 0) {
    return [];
  }
  if (paginationWindow < middleRange[0]) {
    return [1, LEFT_GAP];
  }

  return range(1, middleRange[0] - 1);
}

export function getRightRange(totalPages: number, middleRange: number[]): PageNumber[] {
  if (middleRange.length === 0) {
    return [];
  }
  const endOfMiddleRange = middleRange[middleRange.length - 1];

  if (totalPages > endOfMiddleRange) {
    return [RIGHT_GAP];
  }

  return range(endOfMiddleRange + 1, totalPages);
}

export function getPageNumbers(
  currentPage: number,
  totalPages: number,
  paginationWindow: number = DEFAULT_PAGINATION_WINDOW,
): PageNumber[] {
  const middleRange = getMiddleRange(currentPage, paginationWindow, totalPages);
  const leftRange = getLeftRange(paginationWindow, middleRange);
  const rightRange = getRightRange(totalPages, middleRange);

  return leftRange.concat(middleRange).concat(rightRange);
}

export function isGap(pageNum: PageNumber): pageNum is typeof LEFT_GAP | typeof RIGHT_GAP {
  return pageNum === LEFT_GAP || pageNum === RIGHT_GAP;
}
